import { ShieldCheck } from "lucide-react";
import type { Tab } from "@playbookai/ui";
import { ADMIN_ROUTE } from "../routes.js";

export const ADMIN_TAB_ID = "admin";

export function adminTab(route = ADMIN_ROUTE): Tab {
  return {
    id: ADMIN_TAB_ID,
    label: "Admin console",
    route,
    icon: ShieldCheck,
  };
}
